'use client';
import { getImageUrl, sendRequest } from '@/lib/api-service';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export default function Page() {
	const [ceoMessage, setCeoMessage] = useState('');
	const [kitchenMessage, setKitchenMessage] = useState('');
	const [members, setMembers] = useState<Array<{
		name: string | null;
		occupation?: string | null;
		workedYears?: string | null;
		graduated?: string | null;
		advantages?: string | null;
		instagram?: string | null;
		facebook?: string | null;
		quote?: string | null;
		image: string | null;
	}>>([]);
	const [headerImage, setHeaderImage] = useState<string|null>(null);

	useEffect(() => {
		const fetchTexts = async () => {
			const response = await sendRequest('POST', '/dynamic-texts/', { codes: ["ceo_message", "kitchen_message"] }, true);
			if (response && typeof response === 'object' && !Array.isArray(response)) {
				if ('ceo_message' in response) setCeoMessage(response.ceo_message);
				if ('kitchen_message' in response) setKitchenMessage(response.kitchen_message);
			}
		};

		const fetchTeam = async () => {
			const response = await sendRequest('GET', '/team-members/', {}, true);
			if (response) {
				setMembers(response)
			}
		};
		const fetchDynamicImages = async () => {
			const response = await sendRequest('POST', '/dynamic-images/', {codes:["team"]}, true);
			if (response && Array.isArray(response)) {
				const teamImg = response.find((img: { code: string }) => img.code === "team");
				if (teamImg && teamImg.image) setHeaderImage(teamImg.image);
			}
		};
		fetchDynamicImages();

		fetchTexts();
		fetchTeam();
	}, [setCeoMessage, setKitchenMessage]);

	return (
		<div className="bg-white max-w-[1920px] mx-auto">
			<div className="relative w-full h-[30vh] md:h-[50vh] xl:h-[85vh]">
				{headerImage && (
					<Image
						src={getImageUrl(headerImage)}
						alt="Who we are"
						fill
						className="object-cover"
					/>
				)}
				<div className="absolute inset-0 bg-black/10 flex items-center justify-center">
					<h1 className="text-4xl md:text-6xl font-bold mt-[10vh] md:mt-[15vh] drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 uppercase px-4 text-center">
						Бидний хамт олон
					</h1>
				</div>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/1.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/2.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/3.svg')" }}
				/>
				<div
					className="w-full h-[30vh]  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/low.svg')" }}
				/>
			</div>

			<div className="grid grid-cols-2 max-w-6xl px-5 mx-auto py-20 bg-white gap-y-10 gap-x-4">
				<div className='flex flex-row space-x-4 md:space-x-10 col-span-2'>

					<div className=' flex flex-col space-y-2 mb-10'>
						<h2 className="text-4xl font-semibold text-mountain-900 mb-4">Нарс зуслангийн<br />Захирлын мэндчилгээ:</h2>
						<div className="max-h-[300px] overflow-y-auto text-md md:text-lg">
							<span dangerouslySetInnerHTML={{ __html: ceoMessage }} />
						</div>
					</div>
				</div>

				{members.map((employee, index) => (
					<div
						key={index}
						className="flex flex-row space-x-4 md:space-x-10 col-span-2 md:col-span-1"
					>
						{employee.image && (
							<div className="w-4/10">
								<img
									alt={employee.name || 'Employee Image'}
									src={getImageUrl(employee.image)}
									width={600}
									height={800}
									className="aspect-4/6 rounded-2xl object-cover"
								/>
							</div>
						)}
						<div className="w-6/10 flex flex-col space-y-2">
							<h2 className="text-2xl font-semibold text-mountain-900">{employee.name}</h2>
							{employee.occupation && (
								<div className="text-md text-gray-900 font-semibold">{employee.occupation}</div>
							)}
							{employee.workedYears && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Зусланд ажилласан туршлага:</span> {employee.workedYears}
								</div>
							)}
							{employee.graduated && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Үндсэн мэргэжил:</span> {employee.graduated}
								</div>
							)}
							{employee.advantages && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Давуу тал:</span> {employee.advantages}
								</div>
							)}
							{employee.instagram && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Инстаграмм:</span> <a href={`https://instagram.com/${employee.instagram}`} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">{employee.instagram}</a>
								</div>
							)}
							{employee.facebook && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Facebook:</span> {employee.facebook}
								</div>
							)}
							{employee.quote && (
								<div className="text-sm text-gray-600">
									<span className='font-semibold'>Амрагч хүүхдүүдэд хэлэх үг:</span> {employee.quote}
								</div>
							)}
						</div>
					</div>
				))}





				<div className='flex flex-row space-x-4 md:space-x-10 col-span-2'>
					<div className=' flex flex-col space-y-2 mb-10'>
						<h2 className="text-4xl font-semibold text-mountain-900 mb-4">Гал тогооны ажилчдын танилцуулга:</h2>
						<div className="max-h-[300px] overflow-y-auto text-md md:text-lg">
							<span dangerouslySetInnerHTML={{ __html: kitchenMessage }} />
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}
